import type { ReactNode } from 'react'

import type { Language } from '../../../../../common/types/i18n.js'
import { PageHeader } from '../../../../components/page-header/page-header.js'
import { PageShell } from '../../../../components/page-shell/page-shell.js'
import type { TabItem } from '../../../../components/tabs/tabs.js'
import { Tabs } from '../../../../components/tabs/tabs.js'
import './people-view.css'

export interface PeopleLayoutProps {
    title: string
    search?: ReactNode
    tabItems: TabItem[]
    activeTab: string
    onTabChange: (key: string) => void
    toolbar?: ReactNode
    children: ReactNode
    lang: Language
}

export const PeopleLayout = ({
    title,
    search,
    tabItems,
    activeTab,
    onTabChange,
    toolbar,
    children,
    lang,
}: PeopleLayoutProps) => (
    <PageShell className="portal-people-page">
        <PageHeader title={title} actions={search} />
        <Tabs
            variant="underline"
            items={tabItems}
            activeKey={activeTab}
            onSelect={onTabChange}
            actions={toolbar}
            sticky
            className="portal-people__tabs"
            lang={lang}
        />
        <div className="portal-people__panel">{children}</div>
    </PageShell>
)
